export default "__VITE_ASSET__D7zgwo8v__"